"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ComboStores = require("../../stores/ComboStores");

var _Notification = require("../../components/notificacao/Notification");

var _CircleLoader = require("../../components/progress/CircleLoader");

var _CircleLoader2 = _interopRequireDefault(_CircleLoader);

var _Message = require("../notificacao/Message");

var _Message2 = _interopRequireDefault(_Message);

var _reactCookie = require("react-cookie");

var cookie = _interopRequireWildcard(_reactCookie);

var _jwtDecode = require("jwt-decode");

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

var _detectBrowser = require("../../helpers/detect-browser");

var _detectBrowser2 = _interopRequireDefault(_detectBrowser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var View = function (_React$Component) {
    _inherits(View, _React$Component);

    function View(props) {
        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));

        _this.mountErrorMessage = function (message, error) {
            var cpfConsultarInsc = document.getElementById('cpfUsuario') ? document.getElementById('cpfUsuario').value : "";
            return {
                "color": "#ff4b5c",
                "author_name": (_this.getAuth() ? "Usuario Logado: " + _this.getAuth().username + ". " : "Usuário não logado. ") + " " + ("" + (cpfConsultarInsc.length > 0 ? "CPF Consultar Inscri\xE7\xE3o: " + cpfConsultarInsc + "." : "")),
                "title": "Erro no ReactClient",
                "title_link": window.location.href,
                "text": "Erro ocorrido na página " + window.location.href + ". \n" + "Mensagem: " + message + ". \n" + "Detect-Browser: " + (0, _detectBrowser2.default)() + ". \n" + "STACK: " + error.stack,
                "footer_icon": "https://platform.slack-edge.com/img/default_application_icon.png",
                "ts": new Date().getTime() / 1000
            };
        };

        _this.setNotification = function (n) {
            _this.notificationSystem = n;
        };

        _this.setErrorHandler = function (link) {
            var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            _this.errorHandlerLink = link;
            _this.errorHandler = active;
        };

        _this.redirect = function (url) {
            var history = _this.props.router || _this.props.history;
            history.push(url);
        };

        _this.goBack = function () {
            _this.props.router.goBack();
        };

        _this.getQuery = function () {
            return _this.props.location.query;
        };

        _this.isActionUpdate = function () {
            return _this.props.location.query.acao && _this.props.location.query.acao === 'atualizar';
        };

        _this.isActionDelete = function () {
            return _this.props.location.query.acao && _this.props.location.query.acao === 'deletar';
        };

        _this.displayModal = function (title, description, content, onAgree, onCancel) {
            _this.context.setModalConfig(title, description, content, onAgree, onCancel);
            _this.context.setDisplayModal(true);
        };

        _this.openRightNav = function () {
            _this.context.openRightNav();
        };

        _this.closeRightNav = function () {
            _this.context.closeRightNav();
        };

        _this.getAuth = function () {
            return _this.context.getAuth ? _this.context.getAuth() : null;
        };

        _this.hasRole = function (roles) {
            var authRoles = _this.getAuth().roles.map(function (r) {
                return r.name || r;
            });
            return roles.filter(function (r) {
                return authRoles.includes(r);
            }).length > 0;
        };

        _this.getTokenCredentials = function () {
            var token = cookie.load('token');
            var user = (0, _jwtDecode2.default)(token).usuario;
            return user;
        };

        _this.getCombos = function () {
            return _ComboStores.combos;
        };

        _this.getObjetCombo = function (e, text) {
            return { key: JSON.stringify(e), text: text, value: JSON.stringify(e) };
        };

        _this.createObjectCombo = function (value, text) {
            return { key: value, text: text, value: value };
        };

        _this.hideModal = function () {
            _this.context.setDisplayModal(false);
        };

        _this.getError = function (error) {
            if (typeof error === 'string') return error;
            if (error.response.data === undefined) return "Dados erro indefinido";else if (error.response.data.message !== undefined) return error.response.data.message;else if (_typeof(error.response.data) === 'object') return error.response.data.errorFields ? "Campos requeridos inválidos" : "Ação inválida, tente novamente";else return error.response.data ? error.response.data : "Ocorreu um erro durante a conexão com o servidor.";
        };

        _this.getMessage = function (tipo, titulo, message) {
            var condicao = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            return condicao ? _react2.default.createElement(_Message2.default, { type: tipo, title: titulo, message: message }) : null;
        };

        _this.noResultOnFilter = function () {
            _this.displayModal("Nenhum resultado encontrado", "", "O filtro que você tentou aplicar não retornou nenhum resultado.");
        };

        _this.circleLoader = function (status) {
            var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (status) {
                return _react2.default.createElement(
                    "div",
                    { className: className },
                    _react2.default.createElement(_CircleLoader2.default, null)
                );
            }
        };

        _this.isJson = function (json) {
            try {
                JSON.parse(json);
                return true;
            } catch (e) {
                return false;
            }
        };

        _this.getEditorToolbar = function () {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { image: false };

            var config = {
                options: ['inline', 'fontSize', 'fontFamily', 'remove', 'history', 'textAlign', 'link', 'list', 'image'],
                fontSize: { options: [10, 11, 12, 14, 18] },
                image: {
                    urlEnabled: true,
                    uploadEnabled: true,
                    previewImage: true,
                    uploadCallback: _this.imageUploadCallback,
                    alignmentEnabled: true,
                    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                    alt: { present: false, mandatory: false },
                    defaultSize: {
                        height: 'auto',
                        width: '300'
                    }
                }
            };
            if (!options.image) {
                // remove o ultimo elemento: image
                config.options.pop();
                delete config.image;
            }

            return config;
        };

        _this.getFileBase64 = function (file, callback) {
            var reader = new FileReader();

            // executo o readAsDataURL
            reader.onload = function () {

                // retorna o b64
                callback(reader.result);
            };

            // quando dar erro no onload
            reader.onerror = function (error) {};

            reader.readAsDataURL(file);
        };

        _this.imageUploadCallback = function (file) {
            return new Promise(function (resolve, reject) {
                return _this.getFileBase64(file, function (data) {
                    return resolve({ data: { link: data } });
                });
            });
        };

        _this.getDimmer = function (dimmerText) {
            _this.context.setDimmer(dimmerText);
        };

        _this.isIE = function () {
            var isIE = /*@cc_on!@*/false || !!document.documentMode;
            if (isIE) {
                _this.redirect('/navegadores');
            }
        };

        _this.isMS = function () {
            if ( /*@cc_on!@*/false || !!document.documentMode || window.navigator.userAgent.indexOf("Edge") > -1) {
                _this.redirect('/navegadores');
            }
        };

        _this.notificationSystem = null;
        _this.errorHandler = process.env.NODE_ENV === 'production';
        _this.errorHandlerLink = process.env.REACT_APP_SLACK_HOOKS;

        window.onerror = function (message, source, lineno, colno, error) {
            var attachments = _this.mountErrorMessage(message, error);
            if (_this.errorHandler) {
                _jquery2.default.ajax({
                    type: "POST",
                    url: _this.errorHandlerLink,
                    data: JSON.stringify({ 'attachments': [attachments] }),
                    success: function success() {},
                    dataType: "json"
                });
            }
            return true;
        };
        return _this;
    }

    _createClass(View, [{
        key: "notifyError",
        value: function notifyError(title, error) {
            _Notification.notify.error({
                ref: this.notificationSystem || this.context.notificationSystem(),
                title: title,
                message: this.getError(error)
            });
        }
    }, {
        key: "notifySucess",
        value: function notifySucess(title, message) {
            _Notification.notify.success({
                ref: this.notificationSystem || this.context.notificationSystem(),
                title: title,
                message: message
            });
        }
    }, {
        key: "notifyWarning",
        value: function notifyWarning(title, message) {
            _Notification.notify.warning({
                ref: this.notificationSystem || this.context.notificationSystem(),
                title: title,
                message: message
            });
        }
    }, {
        key: "notifyInfo",
        value: function notifyInfo(title, message) {
            _Notification.notify.info({
                ref: this.notificationSystem || this.context.notificationSystem(),
                title: title,
                message: message
            });
        }
    }, {
        key: "setTabOptions",
        value: function setTabOptions(options) {
            this.context.setTabOptions(options);
        }
    }, {
        key: "removeTab",
        value: function removeTab() {
            this.context.removeTab();
        }
    }, {
        key: "displayToolbar",
        value: function displayToolbar(toolbar, float) {
            this.context.displayToolbar(toolbar, float);
        }
    }, {
        key: "removeToolbar",
        value: function removeToolbar() {
            this.context.removeToolbar();
        }
    }]);

    return View;
}(_react2.default.Component);

exports.default = View;


View.contextTypes = {
    setModalConfig: _propTypes2.default.func,
    setDisplayModal: _propTypes2.default.func,
    notificationSystem: _propTypes2.default.func,
    getAuth: _propTypes2.default.func,
    setTabOptions: _propTypes2.default.func,
    removeTab: _propTypes2.default.func,
    displayToolbar: _propTypes2.default.func,
    removeToolbar: _propTypes2.default.func,
    openRightNav: _propTypes2.default.func,
    closeRightNav: _propTypes2.default.func,
    setDimmer: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/view/View.js
// module id = 193
// module chunks = 0